import { useMutation } from '@tanstack/react-query';
import { aivaApi } from 'src/services';
import { useCallListClient } from './useGetCallList';

export type UseDeleteCallPayload = {
  callId: string;
};

export const useDeleteCall = () => {
  const { deleteCall } = useCallListClient();

  return useMutation({
    mutationKey: ['deleteCall'],
    mutationFn: ({ callId }: UseDeleteCallPayload) => {
      return aivaApi.delete(`/call/${callId}`).then(({ data }) => data);
    },
    onSuccess: (_, { callId }) => {
      deleteCall({ callId });
    },
  });
};
